import {
  BrowserRouter, Routes, Route
} from "react-router-dom";
import "./App.css"

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import PageNotFound from "./pages/PageNotFound";
import QuotePage from "./pages/Quote";
import Photos from "./pages/Photos"
import BusinessCard from "./pages/BusinessCard";
import ReviewPage from "./pages/Review";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/quote" element={<QuotePage/>}/>
          <Route path="/photos" element={<Photos/>}/>
          <Route path="/reviews" element={<ReviewPage/>}/>
          <Route path="/businesscard" element={<BusinessCard/>}/>
          {/* TODO send 404 status codes in the below route */}
          <Route path="*" element={<PageNotFound/>} status={404}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;